import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import Cropper from "cropperjs";

/**
 * Wrapper angular di 
 * https://fengyuanchen.github.io/cropperjs/
 */
@Component({
  selector: 'app-image-cropper',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperComponent {

  @ViewChild("image", { static: false }) public imageElement: ElementRef;

  @Input("src") public imageSource: string;
  @Input() public settings: {square?: boolean} = {};
  
  @Output() confirm: EventEmitter<any> = new EventEmitter<any>();

  private imageDestination: string = "";
  private cropper: Cropper;

  constructor() {}

  ngAfterViewInit(): void {
    this.cropper = new Cropper(this.imageElement.nativeElement, {
      zoomable: false,
      scalable: false,
      aspectRatio: this.settings.square ? 1 : undefined,
      crop: () => {
        const canvas = this.cropper.getCroppedCanvas()
        this.imageDestination = canvas.toDataURL("image/png")
      }
    })
  }

  onCrop() {
    this.confirm.emit(this.imageDestination)
  }
}
